// extracted by mini-css-extract-plugin
module.exports = {"category":"category_category__p2fV1","category__label":"category_category__label__2Ljyb","category__content":"category_category__content__3Bkjb"};